import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEvent } from './MetaPixel';
export function FloatingCta({
  anchorId
}: {
  anchorId: string;
}) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById(anchorId);
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show once the first CTA has scrolled out of view upwards.
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, [anchorId]);
  return <AnimatePresence data-id="element-33" data-mp="bq9eoonxl5zp">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 320,
      damping: 28
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3 pt-2 pointer-events-none" data-id="element-34" data-mp="195wtrgmi5xbj">
          <div className="pointer-events-auto mx-auto w-full max-w-md" data-id="element-35" data-mp="2f4k7eya6c3py">
            <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout')} className="animate-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-renal-500 px-4 py-4 text-center text-[13px] sm:text-[15px] font-extrabold uppercase leading-tight tracking-tight text-white shadow-[0_8px_24px_rgba(10,26,49,0.35)] ring-2 ring-white/70 transition-colors hover:bg-renal-400" data-id="element-36" data-mp="21cnkd8nd4k0f">
              <span className="text-alert-500 text-base leading-none" data-id="element-37" data-mp="1if34gr2ksvry">●</span>
              Quiero mi Ruta Renal por USD 15
            </a>
            <p className="mt-1.5 text-center text-[10.5px] font-semibold text-navy-700/70" data-id="element-38" data-mp="1nepih2q8ag1t">
              Pago único • Acceso de por vida • Garantía 7 días
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}